<template>
    <div class="form-page-section form-bottom-section" v-if="form != null && indexPromo != null">
        <div class="container">
            <div class="column-container">
                <div class="col-left">
                    <div class="form-title">
                        <h2>{{form.top_form_title}}</h2>
                    </div>
                    <formFields class="form-page-setup"></formFields>
                </div>
                <div class="col-right">
                    <div class="form-bg-img">
                        <img :src="form.form_bottom_bg_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import formFields from '@/components/forms/form.vue'
    export default {
        name: 'formBottom',
        data () {
            return {
            }
        },
        components: {
            formFields
        },
        computed: {
            form () {
                return this.$store.state.forms
            },
            indexPromo () {
                return this.$store.state.indexPromo
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-settings.scss';
    @import '@/styles/components/forms/form-bottom.scss';
    @import '@/styles/components/forms/forms-respond/form-settings-respond.scss';
    // @import '@/styles/components/forms/forms-respond/form-bottom-respond.scss';
    // @import '@/styles/components/animation/animation-forms.scss';
</style>